
import { cn } from '@/lib/utils';
import ContactInfo from '@/components/ContactInfo';
import ContactForm from '@/components/ContactForm';

interface ContactSectionProps {
  isVisible: boolean;
}

const ContactSection = ({ isVisible }: ContactSectionProps) => {
  return (
    <section className="py-10 sm:py-12 md:py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-10">
          <div 
            className={cn(
              "bg-white p-4 sm:p-6 md:p-8 rounded-xl shadow-sm transition-all duration-700",
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"
            )}
          >
            <ContactInfo isVisible={isVisible} />
          </div>
          
          <div 
            className={cn(
              "bg-white p-4 sm:p-6 md:p-8 rounded-xl shadow-sm transition-all duration-700 delay-200",
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"
            )}
          >
            <ContactForm isVisible={isVisible} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
